/* Stanbarry Set-Angebot mit Farbe je Stück – ein Code-Stand für alle Stores (Texte über ui_strings, Daten über Produkt-Metafields).
   Kaufbox aus sb-Bausteinen (STYLEGUIDE.md): ① Set = sb-tiers (Stückzahl, Preise wie der Warenkorb), ② Farben = je Stück Farbkreise.
   Stück 1 = Theme-Variante (Farb-Option im Picker ausgeblendet, Galeriebild folgt), der Theme-Preis oben zeigt die gewählte Stufe.
   Vorbelegung der übrigen Stücke: wie Stück 1 oder abwechselnd (cfg.alternate); eine eigene Wahl gilt nur für dieses Stück.
   Stück 1 geht über das Theme-Formular in den Warenkorb, die weiteren vorher per /cart/add.js – alle mit derselben internen
   Property `_Set`, damit ein Rückbau nur dieses Set trifft. Den Set-Preis macht je Stufe ein automatischer Rabatt (README). */
(() => {
'use strict';
const root = document.querySelector('[data-bundle-set]');
if (!root || root.dataset.bsInit) return;
root.dataset.bsInit = '1';
const cfg = JSON.parse(root.querySelector('.bs-config').textContent), T = cfg.t;
const origFetch = window.fetch.bind(window);
const variants = cfg.variants, ids = new Set(variants.map(v => String(v.id)));
const tiers = cfg.tiers.filter(t => t.qty > 1).sort((a, b) => a.qty - b.qty);
const maxQty = tiers.length ? tiers[tiers.length - 1].qty : 1;
const fmt = (s, o) => String(s).replace(/\[(\w+)\]/g, (m, k) => o[k] != null ? o[k] : m);
const sec = root.closest('.shopify-section') || document;
const bundle = root.querySelector('[data-bs-bundle]'), cTitle = root.querySelector('[data-bs-ctitle]');
const colorIdx = cfg.colorOption ? cfg.options.indexOf(cfg.colorOption) : -1;
const colorVals = colorIdx < 0 ? [] : Object.keys(cfg.swatches || {}).length ? Object.keys(cfg.swatches) : [...new Set(variants.map(v => v.options[colorIdx]))];
const state = {qty: 1, colors: [], own: []};
const partEl = i => root.querySelector(`[data-bs-part="${i}"]`);

// ------------------------------------------------------------ Geld (Format aus {{ 1234567 | money }} des Shops)
const rate = cfg.fx ? parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '') : 1;
const money = (() => {
  const s = String(cfg.fmt).trim(), i = s.search(/\d/);
  let j = s.length - 1; while (j >= 0 && !/\d/.test(s.charAt(j))) j--;
  const pre = s.slice(0, i), suf = s.slice(j + 1), core = s.slice(i, j + 1);
  const dec = /\D\d{2}$/.test(core) ? core.charAt(core.length - 3) : '';
  const thou = (dec ? core.slice(0, -3) : core).replace(/\d/g, '').charAt(0);
  return c => {
    c = Math.round(c);
    const whole = dec ? Math.floor(c / 100) : Math.round(c / 100), cents = dec ? dec + ('0' + (c % 100)).slice(-2) : '';
    return pre + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thou) + cents + suf;
  };
})();

// ------------------------------------------------------------ Variante / Theme-Picker (Stück 1)
function variantInput() {
  return sec.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
}
function mainVariant() {
  const inp = variantInput(), id = inp ? String(inp.value) : new URLSearchParams(location.search).get('variant');
  return variants.find(x => String(x.id) === String(id)) || variants[0];
}
function themeOption(name) {
  return [...sec.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"], variant-selects select, variant-radios select')]
    .filter(el => el.name.replace(/^options\[(.*)\]$/, '$1') === name);
}
function hideColorOption() {   // ② ersetzt die Farbe im Theme-Picker (das Theme zeichnet den Picker evtl. neu)
  if (colorIdx < 0) return;
  themeOption(cfg.colorOption).forEach(el => { const fs = el.closest('fieldset') || el.parentElement; if (fs && !fs.classList.contains('sb-hidden-option')) fs.classList.add('sb-hidden-option'); });
}
function chooseColor(val) {   // Farbe der Theme-Variante setzen (Radio/Select des Theme-Pickers, sonst direkt im Formular)
  const els = themeOption(cfg.colorOption), r = els.find(el => el.type === 'radio' && el.value === val), sel = els.find(el => el.tagName === 'SELECT');
  if (r) { if (!r.checked) r.click(); }
  else if (sel) { sel.value = val; sel.dispatchEvent(new Event('change', {bubbles: true})); }
  else {
    const cur = mainVariant(), v = variants.find(x => x.options.every((o, k) => k === colorIdx ? o === val : o === cur.options[k])), inp = variantInput();
    if (v && inp) { inp.value = v.id; inp.dispatchEvent(new Event('change', {bubbles: true})); }
  }
  setTimeout(sync, 30);
}
function partVariant(i) {   // Stück 1 = Theme-Variante, die übrigen = dieselben Optionen mit eigener Farbe
  const base = mainVariant(); if (i === 0 || colorIdx < 0) return base;
  const opts = base.options.slice(); opts[colorIdx] = state.colors[i];
  return variants.find(v => v.options.every((o, k) => o === opts[k]));
}

// ------------------------------------------------------------ Farben je Stück
function defaultColor(i) {
  const c0 = state.colors[0]; if (!cfg.alternate || !colorVals.length) return c0;
  const k = Math.max(0, colorVals.indexOf(c0)); return colorVals[(k + i) % colorVals.length];
}
function follow() { for (let i = 1; i < maxQty; i++) if (!state.own[i]) state.colors[i] = defaultColor(i); }
function setError(i, msg) { const e = partEl(i) && partEl(i).querySelector('[data-bs-err]'); if (e) { e.textContent = msg; e.hidden = !msg; } }
function renderParts() {
  for (let i = 0; i < maxQty; i++) {
    const el = partEl(i); if (!el) continue;
    el.hidden = i >= state.qty;
    const c = state.colors[i], val = el.querySelector('[data-bs-val]'); if (val && c != null) val.textContent = c;
    el.querySelectorAll('[data-bs-color]').forEach(b => b.setAttribute('aria-checked', String(b.dataset.bsColor === c)));
  }
  if (cTitle) { const t = state.qty > 1 ? T.colorMany : T.colorOne; if (cTitle.textContent !== t) cTitle.textContent = t; }
}
function pickColor(i, val) {
  state.colors[i] = val; setError(i, '');
  if (i === 0) { follow(); chooseColor(val); } else state.own[i] = true;
  renderParts();
}

// ------------------------------------------------------------ Preise je Stufe (Stückpreis × n − Rabatt × Kurs, wie der Warenkorb)
let totals = {};
function renderPrices() {
  const v = mainVariant();
  if (!bundle) { totals = v ? {1: {tot: v.price, cmp: Math.max(v.cmp || 0, v.price)}} : {}; return; }
  if (!v || !(rate > 0)) { bundle.hidden = true; return; }
  const c1 = Math.max(v.cmp || 0, v.price);
  let prev = v.price, ok = true; totals = {1: {tot: v.price, cmp: c1}};
  tiers.forEach(t => {
    const tot = t.qty * v.price - Math.round(t.disc * rate), cmp = t.qty * c1;
    if (!(tot >= prev && tot < t.qty * v.price)) ok = false;
    totals[t.qty] = {tot, cmp}; prev = tot;
  });
  root.querySelectorAll('[data-bs-qty]').forEach(el => {
    const r = totals[+el.dataset.bsQty], pe = el.querySelector('[data-bs-price]'); if (!r || !pe) return;
    pe.textContent = money(r.tot);
    const s = el.querySelector('[data-bs-cmp]'); s.textContent = money(r.cmp); s.hidden = !(r.cmp > r.tot);
    const sv = el.querySelector('[data-bs-save]'); if (sv) { sv.textContent = fmt(T.save, {n: Math.round((r.cmp - r.tot) * 100 / r.cmp)}); sv.hidden = !(r.cmp > r.tot); }
  });
  bundle.hidden = !ok;   // nie einen falschen Preis zeigen
  if (!ok && state.qty > 1) setQty(1);
}
// Preis der gewählten Stufe im Theme-Preis oben. Das Theme zeichnet ihn bei jedem Variantenwechsel neu, daher bei jedem sync erneut
function renderHeadPrice() {
  const r = totals[state.qty], box = sec.querySelector('[id^="price-"] .price'); if (!r || !box) return;
  const put = (sel, txt) => box.querySelectorAll(sel).forEach(el => { if (el.textContent.trim() !== txt) el.textContent = txt; });
  put('.price-item--sale', money(r.tot));
  put('.price__regular .price-item--regular', money(r.tot));
  put('.price__sale s.price-item--regular', money(r.cmp));
  const b = box.querySelector('.price__badge-sale');
  if (b && r.cmp > r.tot) { const t = b.textContent.replace(/\d+(?=\s*%)/, Math.round((r.cmp - r.tot) * 100 / r.cmp)); if (t !== b.textContent) b.textContent = t; }
}
function setQty(q) {
  state.qty = Math.max(1, Math.min(q, maxQty));
  root.querySelectorAll('[data-bs-qty]').forEach(b => b.setAttribute('aria-checked', String(+b.dataset.bsQty === state.qty)));
  renderParts();
  renderHeadPrice();
}

// ------------------------------------------------------------ Abgleich mit dem Theme (Stück 1)
let lastId = null;
function sync() {
  hideColorOption();
  const v = mainVariant();
  if (v && String(v.id) !== lastId) {
    lastId = String(v.id);
    if (colorIdx >= 0) { state.colors[0] = v.options[colorIdx]; follow(); renderParts(); }
    renderPrices();
  }
  renderHeadPrice();
}

// ------------------------------------------------------------ Prüfen vor dem Warenkorb
function problem() {
  for (let i = 0; i < state.qty; i++) { const v = partVariant(i); if (!v || !v.ok) return {i, msg: T.errNA}; }
  return null;
}
function showProblem(p) {
  setError(p.i, p.msg);
  const el = partEl(p.i); if (el) el.scrollIntoView({block: 'center', behavior: 'smooth'});
  root.classList.remove('is-shake'); void root.offsetWidth; root.classList.add('is-shake');
}

// ------------------------------------------------------------ Ereignisse
root.addEventListener('click', e => {
  const q = e.target.closest('[data-bs-qty]'); if (q) { setQty(+q.dataset.bsQty); return; }
  const c = e.target.closest('[data-bs-color]'); if (c) pickColor(+c.closest('[data-bs-part]').dataset.bsPart, c.dataset.bsColor);
});
root.addEventListener('keydown', e => {   // Pfeiltasten in den Auswahlgruppen
  const r = e.target.closest('[role="radio"]');
  if (r && /^Arrow(Left|Right|Up|Down)$/.test(e.key)) {
    const all = [...r.parentElement.querySelectorAll('[role="radio"]')], d = /Right|Down/.test(e.key) ? 1 : -1;
    const nb = all[(all.indexOf(r) + d + all.length) % all.length]; e.preventDefault(); nb.focus(); nb.click();
  }
});

// ------------------------------------------------------------ Warenkorb-Einhängen (Theme schickt FormData/JSON an /cart/add)
function variantOf(body) {
  try {
    if (body instanceof FormData || body instanceof URLSearchParams) return String(body.get('id') || '');
    if (typeof body === 'string') {
      try { const j = JSON.parse(body); return String(j.id || (j.items && j.items[0] && j.items[0].id) || ''); }
      catch (_) { return String(new URLSearchParams(body).get('id') || ''); }
    }
  } catch (_) {}
  return '';
}
function withProps(body, props) {
  const put = b => Object.keys(props).forEach(k => b.set(`properties[${k}]`, props[k]));
  if (body instanceof FormData || body instanceof URLSearchParams) { put(body); return body; }
  if (typeof body === 'string') {
    try {
      const j = JSON.parse(body), it = Array.isArray(j.items) ? j.items.find(x => ids.has(String(x.id))) : j;
      if (it) it.properties = Object.assign({}, it.properties, props);
      return JSON.stringify(j);
    } catch (_) { const u = new URLSearchParams(body); put(u); return u.toString(); }
  }
  return body;
}
const fake422 = msg => new Response(JSON.stringify({status: 422, message: 'Cart Error', description: msg}), {status: 422, headers: {'Content-Type': 'application/json'}});
async function addExtras(props) {
  if (state.qty < 2) return [];
  const count = {};
  for (let i = 1; i < state.qty; i++) { const id = partVariant(i).id; count[id] = (count[id] || 0) + 1; }
  const items = Object.keys(count).map(id => ({id: +id, quantity: count[id], properties: props}));
  const res = await origFetch(cfg.cartAddUrl + '.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
  if (!res.ok) throw new Error('extras ' + res.status);
  const j = await res.json().catch(() => ({}));
  return (j.items || []).map(x => x.key).filter(Boolean);
}
async function dropExtras(keys) {
  for (const id of keys || []) await origFetch(cfg.cartAddUrl.replace(/\/add$/, '/change') + '.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id, quantity: 0})}).catch(() => {});
}
window.fetch = function (input, init) {
  const url = typeof input === 'string' ? input : (input && input.url) || '';
  if (!/\/cart\/add/.test(url) || !init || !init.body || !ids.has(variantOf(init.body))) return origFetch(input, init);
  const p = problem();
  if (p) { showProblem(p); return Promise.resolve(fake422(p.msg)); }
  if (state.qty < 2) return origFetch(input, init);
  const props = {_Set: Date.now().toString(36)};
  return addExtras(props).then(keys => {
    const next = Object.assign({}, init, {body: withProps(init.body, props)});
    return origFetch(input, next).then(res => { if (!res.ok) dropExtras(keys); return res; },
                                       e => { dropExtras(keys); throw e; });
  }, () => fake422(T.errCart));
};
const oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.open = function (m, u) { this.__bsUrl = String(u || ''); return oOpen.apply(this, arguments); };
XMLHttpRequest.prototype.send = function (body) {   // fremde Skripte per XHR: nicht verfügbare Auswahl nicht in den Warenkorb
  if (/\/cart\/add/.test(this.__bsUrl || '') && body && ids.has(variantOf(body))) { const p = problem(); if (p) { showProblem(p); return; } }
  return oSend.apply(this, arguments);
};

// ------------------------------------------------------------ Start
sync();
setQty(bundle && !bundle.hidden ? cfg.start || 1 : 1);
setInterval(sync, 400);   // Varianten-Wechsel und Neuzeichnen des Preises durch das Theme – robust für alle alten Themes
document.addEventListener('change', () => setTimeout(sync, 30), true);
})();
